import React, { useState, useEffect } from 'react'
import { inWords } from '../global'

export default function Assetswhatyouown({ summaryData, groupInvestmentData, error }) {

    // eslint-disable-next-line
    const [asset, setAsset] = useState();
    const [riskEquity, setRiskEquity] = useState();
    const [riskDebt, setRiskDebt] = useState();

    // eslint-disable-next-line
    const [investment, setInvestment] = useState([]);
    // eslint-disable-next-line
    const [equity, setEquity] = useState();
    const [debt, setDebt] = useState();
    const [other, setOther] = useState();
    const [epf, setEpf] = useState();

    const [total, setTotal] = useState();


    const [equityBar, setEquityBar] = useState(0);
    const [debtBar, setDebtBar] = useState(0);
    const [otherBar, setOtherBar] = useState(0);

    useEffect(() => {
        if (!groupInvestmentData) return; // Prevents execution if data is missing

        const responseData = groupInvestmentData || {};

        console.log('responseData', responseData);


        setInvestment(responseData.data);

        let find_equity = responseData.sum.find(product => product.name === "Equity");
        setEquity(find_equity ? inWords(find_equity.subTotal) : '00');
        

        let find_debt = responseData.sum.find(product => product.name === "Debt");
        setDebt(find_debt ? inWords(find_debt.subTotal) : '00');

        let find_others = responseData.sum.find(product => product.name === "Property");
        let gold_others = responseData.sum.find(product => product.name === "Gold");
        gold_others = gold_others ? gold_others.subTotal : 0;
        let otherSum = (find_others ? find_others.subTotal : 0) + gold_others;
        setOther(otherSum ? inWords(otherSum) : '');



        // Find all objects where `cat_name` is "Equity"
        let epfProducts = responseData.data.filter(product => product.type_name === "EPF" || product.type_name === "NPS");

        // Sum the `current_value` fields for all equity products
        let totalValue = epfProducts.reduce((acc, product) => acc + parseInt(product.current_value), 0);

        setEpf(totalValue ? inWords(totalValue) : '00');



        setTotal(inWords(responseData.final));


        setEquityBar(find_equity ? Math.round((find_equity.subTotal / responseData.final) * 100) : 0);
        setDebtBar(find_debt ? Math.round((find_debt.subTotal / responseData.final) * 100) : 0);
        setOtherBar(otherSum > 0 ? Math.round((otherSum / responseData.final) * 100) : 0);



        if (summaryData?.status === 100) {
            setAsset(summaryData?.profgoalSummary?.goal_asset_alloc || {});

            if (summaryData?.risk_profile) {
                setRiskEquity(summaryData.risk_profile.max_val || 0);
                setRiskDebt(100 - (summaryData.risk_profile.max_val || 0));
            }
        }
    }, [summaryData, groupInvestmentData]);


    return (
        <>
            <div className="tabContent_title font12 fw500 color7B8 pb15">MyFinsmart / <span className="color263">Personal Information</span></div>

            <div className="font22 fw700 color0C4 pt30">Assets - What you own</div>

            {error && <div className="error-message text-danger font18">{error}</div>} {/* Display error if any */}

            <div className="font14 fw500 color182 mt20">
                Asset Allocation is an investment strategy that aims to balance risk and reward by apportioning a portfolio according to an individuals goals, risk tolerance and investment horizon. Over time, this is one of the most important factors in determining the return on your portfolio, as different assets have different risk reward profile. An appropriate asset allocation can help provide diversification, enhance return potential, lower overall risk & volatility and position your portfolio to take advantage of developing investment opportunities.
            </div>

            <div className="inflowbox_outer mt30">
                <div className="inflowbox_outer_left">
                    <div className="inflowbox_title font12 bluedot fw600 color6d7">Total Assets</div>
                    <div className="font24 fw500 color263 mt12">{!total ? '00' : total}</div>
                </div>
                <div className="inflowbox_outer_right">
                    <div className="totalSaving_box p0 borderzero">
                        <div>
                            <div className="inflowbox_title lightgreendot font12 fw600 color6d7">Equity</div>
                            <div className="font24 fw500 color263 mt12">{!equity ? '00' : equity}</div>
                        </div>
                        <div className="circleBtn_outer">
                            <div className="circleBtn">+</div>
                        </div>
                        <div>
                            <div className="inflowbox_title greendot font12 fw600 color6d7">Debt</div>
                            <div className="font24 fw500 color263 mt12">{!debt ? '00' : debt}</div>
                        </div>
                        <div className="circleBtn_outer">
                            <div className="circleBtn">+</div>
                        </div>
                        <div>
                            <div className="inflowbox_title greendot font12 fw600 color6d7">Others</div>
                            <div className="font24 fw500 color263 mt12">{!other ? '00' : other}</div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="font14 fw500 color182 mt30">Your Assets breakup analysis</div>

            <div className="inflowbox_outer mt15">
                <div className="inflowbox_outer_left">
                    <div className="inflowbox_title lightgreendot font12 fw600 color6d7">EQUITY</div>
                    <div className="font24 fw500 color263 mt12">{!equity ? '00' : equity}</div>
                </div>
                <div className="inflowbox_outer_right">
                    <div className="inflowdtl">
                        {investment.map((data, key) => {
                            return (<>
                                {
                                    data.cat_name === "Equity" && (<>
                                        <div>
                                            <div className="font13 color7B8 fw500">{data.type_name}</div>
                                            <div className="font18 fw500 color263">{inWords(data.current_value)}</div>
                                        </div>
                                    </>)
                                }
                            </>);
                        })}
                    </div>
                </div>
            </div>

            <div className="inflowbox_outer mt15">
                <div className="inflowbox_outer_left">
                    <div className="inflowbox_title greendot font12 fw600 color6d7">DEBT</div>
                    <div className="font24 fw500 color263 mt12">{!debt ? '00' : debt}</div>
                </div>
                <div className="inflowbox_outer_right">
                    <div className="inflowdtl">
                        {investment.map((data, key) => {
                            return (<>
                                {
                                    (data.cat_name === "Debt") && (<>
                                        <div>
                                            <div className="font13 color7B8 fw500">{data.type_name}</div>
                                            <div className="font18 fw500 color263">{inWords(data.current_value)}</div>
                                        </div>
                                    </>)
                                }
                            </>);
                        })}
                    </div>
                </div>
            </div>


                        <div className="inflowbox_outer mt15">
                <div className="inflowbox_outer_left">
                    <div className="inflowbox_title greendot font12 fw600 color6d7">EPF</div>
                    <div className="font24 fw500 color263 mt12">{!epf ? '00' : epf}</div>
                </div>
                <div className="inflowbox_outer_right">
                    <div className="inflowdtl">
                        {investment.map((data, key) => {
                            return (<>
                                {
                                    (data.cat_name === "Others") && (<>
                                        <div>
                                            <div className="font13 color7B8 fw500">{data.type_name}</div>
                                            <div className="font18 fw500 color263">{inWords(data.current_value)}</div>
                                        </div>
                                    </>)
                                }
                            </>);
                        })}
                    </div>
                </div>
            </div>

            <div className="inflowbox_outer mt15">
                <div className="inflowbox_outer_left">
                    <div className="inflowbox_title greendot font12 fw600 color6d7">Others</div>
                    <div className="font24 fw500 color263 mt12">{!other ? '00' : other}</div>
                </div>
                <div className="inflowbox_outer_right">
                    <div className="inflowdtl">
                        {investment.map((data, key) => {
                            return (<>
                                {
                                    (data.cat_name === "Property" || data.cat_name === "Gold") && (<>
                                        <div>
                                            <div className="font13 color7B8 fw500">{data.type_name}</div>
                                            <div className="font18 fw500 color263">{inWords(data.current_value)}</div>
                                        </div>
                                    </>)
                                }
                            </>);
                        })}

                    </div>
                </div>
            </div>


            <div className="font14 fw500 color182 mt30">Your Assets Allocation</div>

            <div className="inflowbox_outer mt15">
                <div className="inflowbox_outer_left">
                    <div className="inflowbox_title orangedot font12 fw600 color6d7">As Per Risk</div>
                </div>
                <div className="inflowbox_outer_right">
                    <div className="inflowdtl">
                        <div>
                            <div className="font13 color7B8 fw500">{"Equity"}</div>
                            <div className="font18 fw500 color263">{riskEquity ? riskEquity + '%' : 'NA'}</div>
                        </div>
                        <div>
                            <div className="font13 color7B8 fw500">{"Debt"}</div>
                            <div className="font18 fw500 color263">{riskDebt ? riskDebt + '%' : 'NA'}</div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="inflowbox_outer mt15">
                <div className="inflowbox_outer_left">
                    <div className="inflowbox_title bluedot font12 fw600 color6d7">As Per Goals</div>
                </div>
                <div className="inflowbox_outer_right">
                    <div className="inflowdtl">
                        <div>
                            <div className="font13 color7B8 fw500">{"Equity"}</div>
                            <div className="font18 fw500 color263">{asset ? Math.round(asset) + '%' : 'NA'}</div>
                        </div>
                        <div>
                            <div className="font13 color7B8 fw500">{"Debt"}</div>
                            <div className="font18 fw500 color263">{asset ? Math.round(100 - asset) + '%' : 'NA'}</div>
                        </div>
                    </div>
                </div>
            </div>


            <div className="inflowbox_outer mt15">
                <div className="inflowbox_outer_left">
                    <div className="inflowbox_title greendot font12 fw600 color6d7">As Current Investments</div>
                </div>
                <div className="inflowbox_outer_right">
                    <div className="inflowdtl">
                        <div>
                            <div className="font13 color7B8 fw500">{"Equity"}</div>
                            <div className="font18 fw500 color263">{equityBar ? equityBar + '%' : 'NA'}</div>
                        </div>
                        <div>
                            <div className="font13 color7B8 fw500">{"Debt"}</div>
                            <div className="font18 fw500 color263">{debtBar ? debtBar + '%' : 'NA'}</div>
                        </div>
                        <div>
                            <div className="font13 color7B8 fw500">{"Others"}</div>
                            <div className="font18 fw500 color263">{otherBar ? otherBar + '%' : 'NA'}</div>
                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}
